module.exports = __webpack_public_path__ + "static/img/contestant-bg.b31d91b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contestant-bg.jpg
// module id = H+Eu
// module chunks = 1